import React, {useState, useEffect} from 'react';
import { Form, Col, Container, Row, Card, Button } from 'react-bootstrap';
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { unlistUsersSurveyData } from './ManageUsersSurveyDataSlice';
import { unlistSurveyUsers } from '../managesurveyusers/ManageSurveyUsersSlice';
import { UsersSurveyData } from './ManageUsersSurveyData';
import API from '../../services/api';
import { SURVEYS_API_URL, USERS_API_URL } from '../../config/service';
import { makeAdminUser } from '../makeadmin/makeAdminSlice';
import { revokeAdminUser } from '../revokeadmin/revokeAdminSlice';
import { selectUser } from '../auth/authSlice';
import { selectUsers } from '../userlist/usersListSlice';

export const ManageUserDetails = () => {

    const [surveyState, setSurveyState] = useState({});
    const [groupState, setGroupState] = useState({});
    const [loadState, setLoadState] = useState(true);
    const [isAdmin, setIsAdmin] = useState(null);
    const [actionLoading, setActionLoading] = useState(false);
    const user = useSelector(selectUser);
    const usersList = useSelector(selectUsers);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const selectedUser = location.pathname.split('details/')[1];

    function byKey(arr, key) {
        for (var i = 0, L = arr.length; i < L; i++) {
            if (arr[i].username === key) {
                return arr[i].email;
            }
        }
    }


    useEffect(() => {
        let isMounted = true;
    
        async function load() {
            try {
                const groupResponse = await API.get(`${USERS_API_URL}/v1/users/groups/${selectedUser}`);
                const surveyResponse = await API.get(`${SURVEYS_API_URL}/v1/surveys/users/allocated/${selectedUser}`);
                
                if (isMounted) {
                    setGroupState(groupResponse.data);
                    const groups = groupResponse.data;
                    setIsAdmin(groups.includes("BUSINESS_ADMINS") || groups.includes("CSO_ADMINS"));
                    setSurveyState(surveyResponse.data.Items);
                    dispatch(unlistUsersSurveyData());
                    setLoadState(false);
                }
            } catch (error) {
                if (isMounted) console.error("Error loading assigned data:", error);
            }
        }
    
        load();
        dispatch(unlistSurveyUsers());
    
        return () => { isMounted = false; }; // cleanup on unmount
    }, [selectedUser]);

    async function handleMakeAdmin() {
        setActionLoading(true);
        const res = await dispatch(makeAdminUser(selectedUser));
        if (res === true) {
            setIsAdmin(true);
        }
        setActionLoading(false);
    }

    async function handleRevokeAdmin() {
        setActionLoading(true);
        const res = await dispatch(revokeAdminUser(selectedUser));
        if (res === true) {
            setIsAdmin(false);
        }
        setActionLoading(false);
    }

    return (
        <div>
            <Container className="pt-5">
                <Card>
                    <Card.Header style={{ backgroundColor: "#FBAA34", color: "white" }}>
                        <h3>User Details</h3>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <Form.Group as={Row}>
                                <Form.Label column sm="8">Username</Form.Label>
                                <Col sm="10">
                                    <Form.Control type="text" readOnly defaultValue={selectedUser} />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="8">Email</Form.Label>
                                <Col sm="10">
                                    <Form.Control type="text" readOnly defaultValue={byKey(usersList, selectedUser)} />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="8">Account Admin</Form.Label>
                                {isAdmin !== null ? (
                                    <Col sm="10">
                                        <Form.Control type="text" readOnly value={isAdmin ? "True" : "False"} />
                                        <br />

                                        {isAdmin ? (
                                            <Button
                                                disabled={actionLoading || selectedUser === user.username}
                                                onClick={handleRevokeAdmin}
                                                variant="danger"
                                            >
                                                {actionLoading ? "Processing..." : "Revoke Admin"}
                                            </Button>
                                        ) : (
                                            <Button
                                                disabled={actionLoading}
                                                onClick={handleMakeAdmin}
                                                variant="info"
                                            >
                                                {actionLoading ? "Processing..." : "Make Admin"}
                                            </Button>
                                        )}

                                        <div className="pt-2 pr-2">
                                            <Button onClick={() => history.goBack()} variant='info'>
                                                Back to Home
                                            </Button>
                                        </div>
                                    </Col>
                                ) : (
                                    <div>Loading...</div>
                                )}
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="8">Allocated Surveys</Form.Label>
                                <Col sm="10">
                                    {loadState === false ? (
                                        <UsersSurveyData surveys={surveyState} user={selectedUser} />
                                    ) : (
                                        <div>Loading...</div>
                                    )}
                                </Col>
                            </Form.Group>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}